"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
require("./l1-hero.styles.css");
var L1Hero = function (props) {
  var bem = (0, hook_use_bem_classes_1.default)('rwc-l1-hero');
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: bem()
  }, {
    children: [(0, jsx_runtime_1.jsxs)("picture", __assign({
      className: bem('bg-image')
    }, {
      children: [(0, jsx_runtime_1.jsx)("source", {
        media: "(min-width:577px)",
        srcSet: props.backgroundImageDesktop
      }), (0, jsx_runtime_1.jsx)("source", {
        media: "(max-width:576px)",
        srcSet: props.backgroundImageMobile
      }), (0, jsx_runtime_1.jsx)("img", {
        srcSet: props.backgroundImageDesktop,
        alt: props.backgroundImageAlt
      })]
    })), (0, jsx_runtime_1.jsx)("div", {
      className: bem('gradient-overlay')
    }), (0, jsx_runtime_1.jsx)("div", __assign({
      className: bem('content-container')
    }, {
      children: (0, jsx_runtime_1.jsxs)("div", __assign({
        className: bem('content')
      }, {
        children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "h1",
          className: bem('title')
        }, {
          children: props.title
        })), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "div",
          className: bem('description')
        }, {
          children: props.description
        }))]
      }))
    }))]
  }));
};
exports.default = L1Hero;